import { EndpointKey } from '../modules/types/uploadEndpoint';

const CHANNEL_NAME = 'scrappbook-upload-endpoint';

let channel: BroadcastChannel | null = null;

const getChannel = (): BroadcastChannel | null => {
  if (channel) return channel;
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') return null;
  channel = new BroadcastChannel(CHANNEL_NAME);

  return channel;
};

export const broadcastUploadEndpoint = (endpoint: EndpointKey): void => {
  getChannel()?.postMessage({ endpoint });
};

export const subscribeUploadEndpoint = (handler: (endpoint: EndpointKey) => void): void => {
  const ch = getChannel();
  if (!ch) return;
  ch.addEventListener('message', (event: MessageEvent) => {
    if (event.data?.endpoint) handler(event.data.endpoint);
  });
};
